export const THEMES = ["dark", "light"] as const;
export type Theme = typeof THEMES[number];

const THEME_STORAGE_KEY = "vtms.theme";
const DEFAULT_THEME: Theme = "dark";

// Names from before the two-theme simplification, still present in saved prefs.
const LEGACY_THEMES: Record<string, Theme> = { synthwave: "dark", daylight: "light" };

export function isValidTheme(theme: unknown): theme is Theme {
  return typeof theme === "string" && THEMES.includes(theme as Theme);
}

export function loadTheme(): Theme {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (isValidTheme(saved)) {
      return saved;
    }
    if (saved !== null && saved in LEGACY_THEMES) {
      return LEGACY_THEMES[saved]!;
    }
  } catch {
    // localStorage unavailable (private mode / kiosk) — fall back to default
  }
  return DEFAULT_THEME;
}

export function saveTheme(theme: Theme): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // localStorage unavailable — theme simply won't persist
  }
}

export function applyTheme(theme: Theme): void {
  if (isValidTheme(theme)) {
    document.documentElement.dataset.theme = theme;
  } else {
    document.documentElement.dataset.theme = DEFAULT_THEME;
  }
}
